<template>
  <a v-if="href"
     :href="href"
     target="_self"
     class="list-group-item list-group-item-action"
     @click="onClick"><slot/></a>
  <div v-else class="list-group-item"><slot/></div>
</template>

<script setup>
// Replaces bootstrap-vue's <b-list-group-item> with the same markup (only what the app uses: href and click).
defineOptions({
  name: 'BListGroupItem',
})

const props = defineProps({
  href: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['click'])

const onClick = (event) => {
  emit('click', event)
  // as bootstrap-vue's link: href="#" is only a placeholder, the page must not jump to the top
  if(props.href === '#') event.preventDefault()
}
</script>
